import settingsService from '../api';
import { SET_SETTINGS, SET_REVIEWS, SET_SUBSCRIBES } from './settings.constants';
import { SubscribeDTO, Snackbar } from "@entities/dtos";
import { setAlertAC } from '@entities/notifications/model/notifications.actions';


export const getSettingsTC = () => {
  return async (dispatch) => {
    try {
      const resp = await settingsService.getSettings();

      if (!resp?.data) {
        return;
      }

      dispatch(setSettingsAC(resp.data));
    } catch (error) {
      console.log(error);
    }
  };
};

export const getReviewsTC = () => {
  return async (dispatch) => {
    try {
      const response = await settingsService.getReviews();

      if (!response?.data) {
        return;
      }

      dispatch(setReviewsAC(response.data));
    } catch (error) {
      console.log(error);
    }
  }
}

export const getAllSubscribesTC = () => {
  return async (dispatch) => {
    try {
      const response = await settingsService.getAllSubscribes();

      if (!response?.data) {
        return;
      }

      const subscribes = response.data.map(item => new SubscribeDTO(item));

      dispatch(setAllSubscribesAC(subscribes));
    } catch (error) {
      console.log(error);
    }
  }
}

export const getAllSubscribesAdminTC = () => {
  return async (dispatch) => {
    try {
      const response = await settingsService.getAllSubscribesAdmin();

      if (!response?.data) {
        return;
      }

      const subscribes = response.data.map(item => new SubscribeDTO(item));

      dispatch(setAllSubscribesAC(subscribes));
    } catch (error) {
      console.log(error);
    }
  }
}

export const settingsUpdateSubscribesTC = (formData) => {
  return async (dispatch) => {
    try {
      const response = await settingsService.updateSubscribes(formData);

      if (response?.status === 200) {
        try {
          const data = JSON.parse(response?.config?.data);
          const subscribes = data.map(item => new SubscribeDTO(item));

          dispatch(setAllSubscribesAC(subscribes));
        } catch (e) {
          console.log(e);
        }

        const snackbar = new Snackbar({
          status: 200,
          message: (
            <div className="">
              <h5 className="snack__header">
                Saved settings sussess
              </h5>
            </div>
          ),
        });
        dispatch(setAlertAC(snackbar));
      }
    } catch (error) {
      console.log(error);
      const snackbar = new Snackbar({
        status: 500,
        message: (
          <div className="">
            <h5 className="snack__header">
              Can't save settings.
            </h5>
          </div>
        ),
      });
      dispatch(setAlertAC(snackbar));
    }
  }
}

//ACTIONS
export const setSettingsAC = (payload) => {
  return {
    type: SET_SETTINGS,
    payload,
  };
};

export const setReviewsAC = (payload) => {
  return {
    type: SET_REVIEWS,
    payload,
  };
};

export const setAllSubscribesAC = (payload) => {
  return {
    type: SET_SUBSCRIBES,
    payload,
  };
};